<template>
    <div class="pp-pull-refresh"
        @touchstart.stop="start" 
        @touchmove.stop="drag" 
        @touchend.stop="release">
        <div ref="pull"
            :class="[
                'pp-pull-refresh__prefix',
                {'refresh': isPullRefresh}
            ]">
            <i class="pp-pull-refresh__prefix-icon pp-icon-pull"></i>
            {{isPullRefresh ? '释放刷新...' : '下拉刷新...'}}
        </div>
        <div ref="wrap" class="pp-pull-refresh__wrap">
            <div ref="container" class="pp-pull-refresh__body">
                <slot></slot>
            </div>
            <!-- <div v-if="loading" ref="loading">
                <svg class="pp-loading__svg" viewBox="0 0 100 100">
                    <circle class="pp-loading__circle" 
                        cx="50" cy="50" r="30" 
                        fill="transparent"
                        stroke-width="3">
                    </circle>
                </svg>
            </div> -->
        </div>
        <div ref="push"
            :class="[
                'pp-pull-refresh__suffix',
                {'more': isPushMore}
            ]">
            <i class="pp-pull-refresh__prefix-icon pp-icon-push"></i>
            {{!isPushMore ? '上滑加载更多...' : '释放加载更多...'}}
        </div>
    </div>
</template>

<script>
/**
 * 下拉刷新、上滑加载
 * @param {boolean} push 开启上滑加载
 * 
 * @event refresh 下拉刷新
 * @event more 上滑加载
 */
export default {
    name: 'pp-pull-refresh',
    props : {
        push: Boolean,
        loading: Boolean,
    },
    data : function() {
        return {
            pullPosition : {}, //触摸点定位
            pushPosition : {},
            isPullRefresh : false, //是否符合下拉刷新的触发
            isPushMore : false, //上滑加载数据
        };
    },
    methods : {
        isTop: function() {
            return this.$refs['wrap'].scrollTop === 0;
        },

        isBottom: function() {
            let wrap = this.$refs['wrap'].offsetHeight;
            let height = this.$refs['container'].offsetHeight;
            let scroll = this.$refs['wrap'].scrollTop;

            return wrap + scroll >= height;
        },

        isTouchTop: function(e) {
            return e.touches[0].clientY <= this.$el.clientHeight / 2;
        },

        /**
        * 重置下拉触摸点定位，发送下拉刷新事件 / 上滑加载事件
        */
        release : function(e) { 
            if(this.pullPosition.move && this.pullPosition.start) {
                this.$refs['wrap'].style.transform = "translate3d(0, 0, 0)"
                this.$refs['wrap'].style.transition = "all .25s"

                this.pullPosition = {}

                this.isPullRefresh && this.$emit('refresh', true)
                this.isPullRefresh = false
            }

            if(this.pushPosition.move && this.pushPosition.start) {
                this.$refs['wrap'].style.transform = "translate3d(0, 0, 0)"
                this.$refs['wrap'].style.transition = "all .25s"

                this.pushPosition = {}

                this.isPushMore && this.$emit('more', true)
                this.isPushMore = false
            }
        },

        /**
        * 符合触发条件，下拉内容框，打开触发下拉刷新事件的开关
        */
        drag : function(e) {
            if(this.isTop() && this.pullPosition.start) { //下拉
                this.pullPosition.move = {
                    x : e.touches[0].clientX,
                    y : e.touches[0].clientY
                }

                let subY = this.pullPosition.move.y - this.pullPosition.start.y;

                if(subY > 0) {
                    let height = this.$refs['pull'].offsetHeight;
                    if(subY >= height) {
                        subY = subY >= height ? height : subY
                        this.isPullRefresh = true
                    }
                    else {
                        this.isPullRefresh = false
                    }

                    this.$refs['wrap'].style.transform = `translate3d(0, ${subY}px, 0)`
                    this.$refs['wrap'].style.transition = 'none'
                };
                e.preventDefault()
            }
            else if(this.isBottom() && this.pushPosition.start) { //上滑 
                this.pushPosition.move = {
                    x : e.touches[0].clientX,
                    y : e.touches[0].clientY
                }

                let subY = this.pushPosition.move.y - this.pushPosition.start.y;

                if(subY < 0) {
                    let height = this.$refs['push'].offsetHeight;

                    if(Math.abs(subY) > height) {
                        subY = -height
                        this.isPushMore = true
                    }
                    else {
                        this.isPushMore = false
                    }

                    this.$refs['wrap'].style.transform = `translate3d(0, ${subY}px, 0)`
                    this.$refs['wrap'].style.transition = 'none'
                }
            }
            else {
                this.isPushMore = false
                this.isPullRefresh =false
            }
        },

        /**
        * 设置触摸点定位
        */
        start : function(e) {
            if(this.isTop() && this.isTouchTop(e)) { //下拉
                this.pullPosition.start = {
                    x : e.touches[0].clientX,
                    y : e.touches[0].clientY
                }
            }
            else if(this.push && this.isBottom()) { //上滑
                this.pushPosition.start = {
                    x : e.touches[0].clientX,
                    y : e.touches[0].clientY
                }
            }
        },

        /**回到顶部 */
        goTop: function() {
            this.$refs['wrap'].scrollTop = 0
        },
    },
}
</script>
